import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Locale, DEFAULT_LOCALE, detectBrowserLocale } from '@packages/global';

import zhCommon from './locales/zh-CN/common.json';
import enCommon from './locales/en-US/common.json';
import zhNav from './locales/zh-CN/nav.json';
import enNav from './locales/en-US/nav.json';
import zhAuth from './locales/zh-CN/auth.json';
import enAuth from './locales/en-US/auth.json';
import zhApp from './locales/zh-CN/app.json';
import enApp from './locales/en-US/app.json';

function getInitialLocale(): Locale {
  try {
    const stored = localStorage.getItem('language-storage');
    if (stored) {
      const { state } = JSON.parse(stored);
      if (state?.locale) return state.locale as Locale;
    }
  } catch {}
  return detectBrowserLocale(navigator?.language);
}

i18n.use(initReactI18next).init({
  lng: getInitialLocale(),
  fallbackLng: DEFAULT_LOCALE,
  defaultNS: 'common',
  resources: {
    [Locale.ZH_CN]: { common: zhCommon, nav: zhNav, auth: zhAuth, app: zhApp },
    [Locale.EN_US]: { common: enCommon, nav: enNav, auth: enAuth, app: enApp },
  },
  interpolation: { escapeValue: false },
});

export default i18n;
